/* eslint import/no-webpack-loader-syntax: off */

import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import Settings from '-!svg-react-loader!./settings.svg';
import { Link, NavLink } from 'react-router-dom';
import { Theme } from '../../config/theme';

export default class SettingsMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menuOpen: false,
    };

    this.logoutHandler = this.props.logoutHandler.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu(e, preventDefault) {
    if (preventDefault) e.preventDefault();
    this.setState({
      menuOpen: !this.state.menuOpen,
    });
  }

  render() {
    return (
      <div
        className={css(styles.container, this.state.menuOpen ? styles.container_top : null) + ' SVGContainer SettingsSVG'}
        onMouseEnter={!Theme.isMobile && !this.state.menuOpen ? this.toggleMenu : null}
        onMouseLeave={!Theme.isMobile && this.state.menuOpen ? this.toggleMenu : null}>
        {Theme.isMobile && this.state.menuOpen ?
          <div className={css(styles.close)} onClick={this.toggleMenu} role="button" tabIndex={0} />
        : null}
        <Link
          to="/settings/profiles"
          className={css(styles.link)}
          onClick={Theme.isMobile ? e => this.toggleMenu(e, true) : null}
          >
          <Settings className={css(styles.icon)} />
        </Link>
        <ul className={css(styles.menu, this.state.menuOpen ? styles.menu_open : null)}>
          <li className={css(styles.item)}>
            <NavLink
              to="/settings/details"
              className={css(styles.link)}
              onClick={Theme.isMobile ? this.toggleMenu : null}
            >
              My Details
            </NavLink>
          </li>
          <li className={css(styles.item)}>
            <NavLink
              to="/settings/membership"
              className={css(styles.link)}
              onClick={Theme.isMobile ? this.toggleMenu : null}
            >
              My Membership
            </NavLink>
          </li>
          <li className={css(styles.item)}>
            <NavLink
              to="/settings/account"
              className={css(styles.link)}
              onClick={Theme.isMobile ? this.toggleMenu : null}
            >
              My Settings
            </NavLink>
          </li>
          <li className={css(styles.item)}>
            <NavLink
              to="/settings/resources"
              className={css(styles.link)}
              onClick={Theme.isMobile ? this.toggleMenu : null}
            >
              My Dog e-Bag
            </NavLink>
          </li>
          <li className={css(styles.item)}>
            <NavLink
              to="/settings/help"
              className={css(styles.link)}
              onClick={Theme.isMobile ? this.toggleMenu : null}
            >
              Help
            </NavLink>
          </li>
          <li className={css(styles.item)}>
            <div
              className={css(styles.link)}
              onClick={this.logoutHandler}
              role="button"
              tabIndex={0}>Logout</div>
          </li>
        </ul>
      </div>
    );
  }
}

SettingsMenu.propTypes = {
  logoutHandler: PropTypes.func.isRequired,
};

const styles = StyleSheet.create({
  close: {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    content: '""',
  },
  container_top: {
    zIndex: 9,
  },
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    height: Theme.navigation.height,
    marginLeft: 10,
    marginRight: 10,

    [Theme.mobile_query]: {
      position: 'static',
      marginLeft: 5,
      marginRight: 5,
    },
  },

  icon: {
    transition: 'fill linear, transform cubic-bezier(0.175, 0.885, 0.320, 1.275)',
    transitionDuration: '300ms',
  },

  item: {
    width: '100%',
    ':not(:last-child)': {
      borderBottom: 'solid 1px #16345a',
    },
  },

  link: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    textAlign: 'center',
    height: 60,
    lineHeight: '60px',
    color: '#fff',
    transition: 'all 300ms',

    ':hover': {
      backgroundColor: '#fff',
      color: '#021a36',
    },

    ':hover > svg': {
      fill: '#39b4d6',
      transform: 'rotate(360deg)',

      [Theme.mobile_query]: {
        fill: '#000',
      },
    },
  },

  menu: {
    position: 'absolute',
    top: '100%',
    right: -10,
    width: 240,
    color: Theme.white,
    backgroundColor: '#021a36',
    transformOrigin: 'top center',
    transition: 'all 500ms cubic-bezier(0.175, 0.885, 0.320, 1.275)',
    pointerEvents: 'none',
    opacity: 0,
    transform: 'rotateX(-100deg)',
    textAlign: 'center',

    [Theme.mobile_query]: {
      right: 0,
      width: '100vw',
    },
  },
  menu_open: {
    transform: 'rotate(0deg)',
    opacity: 1,
    pointerEvents: 'initial',
  },
});



// WEBPACK FOOTER //
// ./src/components/SettingsMenu/index.js